import React from 'react'
import { TFunction } from 'next-i18next'
import * as icons from '@ant-design/icons'

export interface AdminButton {
  text: string,
  link: string
  icon: React.ReactNode
}

export const leftButtons = (t: TFunction): AdminButton[] => [
  { text: t('admin.certificateSubmitText'), link: '/admin/generate-certificate', icon: <icons.DeliveredProcedureOutlined /> },
  { text: t('admin.CalculateMassive'), link: '/admin/massive-calculation', icon: <icons.LineChartOutlined /> },
  { text: t('admin.Brokerage.ButtonText'), link: '/admin/brokerage', icon: <icons.ShoppingCartOutlined /> },
  { text: t('Invoices.Title'), link: '/admin/download-invoices', icon: <icons.DownloadOutlined /> },
  { text: t('Cabify.ManageCabifyProcess'), link: '/admin/manage-cabify-process', icon: <icons.CarOutlined/> },
  { text: t('admin.ViewData'), link: '/admin/metabase-data', icon: <icons.DatabaseOutlined /> },
  { text: t('admin.Vouchers'), link: '/admin/discount-vouchers', icon: <icons.TagsOutlined /> },
  { text: t('Push notifications'), link: '/admin/push-notifications', icon: <icons.NotificationOutlined /> },
]

export const rigthButtons = (t: TFunction): AdminButton[] => [
  { text: t('Validate.Title'), link: '/admin/validate-users', icon: <icons.UserOutlined /> },
  { text: t('Withdrawals.Validate'), link: '/admin/validate-withdrawals', icon: <icons.LogoutOutlined /> },
  { text: t('Document.Title'), link: '/admin/validate-documents', icon: <icons.FileDoneOutlined /> },
  { text: t('Transfer.Title'), link: '/admin/validate-transfers', icon: <icons.CarryOutOutlined /> },
  { text: t('ValidateDeposits.Title'), link: '/admin/validate-deposits', icon: <icons.DollarCircleOutlined /> },
]
